import { useEffect, useRef, useState } from "react";
import { api, downloadAuthed } from "@/lib/api";
import { Loader2, Upload } from "lucide-react";

export default function ExportWithPhotos({ kind, plainPath, plainName, params, testid }) {
    const [withPhotos, setWithPhotos] = useState(false);
    const [job, setJob] = useState(null);
    const timer = useRef(null);
    useEffect(() => () => clearInterval(timer.current), []);

    const run = async () => {
        if (!withPhotos) {
            downloadAuthed(plainPath, plainName, params).catch((e) => alert(e.message));
            return;
        }
        try {
            const { data } = await api.post(`/admin/exports/${kind}`, null, { params });
            setJob({ status: "running", done: 0, total: 0 });
            timer.current = setInterval(async () => {
                const { data: s } = await api.get(`/admin/exports/job/${data.job_id}`);
                setJob(s);
                if (s.status === "done") {
                    clearInterval(timer.current);
                    await downloadAuthed(`/admin/exports/job/${data.job_id}/download`, s.filename);
                    setTimeout(() => setJob(null), 2500);
                } else if (s.status === "error") {
                    clearInterval(timer.current);
                }
            }, 2500);
        } catch (e) {
            setJob({ status: "error", error: e.response?.data?.detail || e.message });
        }
    };

    const busy = job?.status === "running";
    return (
        <span className="inline-flex items-center gap-2 flex-wrap">
            <button type="button" onClick={run} disabled={busy} className="btn-outline" data-testid={testid}>
                {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Upload className="w-4 h-4 rotate-180" />}
                {busy ? `Foto ${job.done}/${job.total || "…"}` : "Export XLSX"}
            </button>
            <label className="inline-flex items-center gap-1.5 text-xs font-mono cursor-pointer select-none" data-testid={`${testid}-photos-toggle`}>
                <input type="checkbox" checked={withPhotos} onChange={(e) => setWithPhotos(e.target.checked)} disabled={busy} data-testid={`${testid}-photos-checkbox`} />
                Me foto
            </label>
            {job?.status === "done" && <span className="text-xs text-emerald-600" data-testid={`${testid}-done`}>Gati ✓</span>}
            {job?.status === "error" && <span className="text-xs text-red-600" data-testid={`${testid}-error`}>{job.error || "Dështoi"}</span>}
        </span>
    );
}
